// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"ceb13804","242":"edfa2d7f","818":"7491870a","845":"5b89592a"}[chunkId] + ".chunk.js";
};